<template>
  <div>
    <b-row class="d-flex align-items-center">
      <b-col cols="8">
        <h1 class="font-weight-bolder mb-0">Money Back Special Builder</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="text-right">
        <b-button
          @click="$router.push('/promotions/money-back-specials')"
          variant="outline-secondary"
          class="mr-1"
        >
          Cancel
        </b-button>
        <b-button
          @click="
            handleCreatePromotion({ status: 'inactive', action: 'draft' })
          "
          variant="outline-secondary"
          class="mr-1"
          :disabled="loadingAction === 'draft' && loadingCreatePromotion"
          style="min-width: 136px"
        >
          Save as Draft
        </b-button>

        <b-button
          :disabled="loadingAction === 'publish' && loadingCreatePromotion"
          @click="
            handleCreatePromotion({ status: 'active', action: 'publish' })
          "
          variant="primary"
          style="min-width: 172px"
          class="mr-1"
        >
          Publish Promotion
        </b-button>
        <b-button
          :disabled="loadingAction === 'now' && loadingCreatePromotion"
          @click="
            handleCreatePromotion({
              status: 'active',
              isNow: true,
              action: 'now',
            })
          "
          variant="primary"
          style="min-width: 172px"
        >
          Publish Promotion Now
        </b-button>
      </b-col>
    </b-row>

    <validation-observer ref="validateMBSForm">
      <b-row class="mt-2">
        <b-col cols="12">
          <b-card>
            <b-row>
              <b-col cols="12">
                <b-form-group
                  class="font-weight-bold"
                  label="Promotion Name (Internal Description)"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="name"
                    rules="required"
                  >
                    <b-form-input
                      placeholder="June 100% Deposit Bonus"
                      v-model="name"
                      type="text"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mt-1">
              <b-col cols="12">
                <p class="font-weight-bold mb-0">
                  Description (Customer Description)
                </p>
                <b-form-textarea
                  placeholder="Get a 100% match when you deposit up to $500 for a limited time!"
                  rows="1"
                  no-resize
                  v-model="description"
                ></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col cols="12">
                <p class="font-weight-bold mb-0">Description Format Text</p>
                <vue2-tinymce-editor
                  :key="'descriptionHTML'"
                  id="descriptionHTML"
                  v-model="descriptionHTML"
                  :options="{ ...editorOptions }"
                />
              </b-col>
            </b-row>

            <b-row class="mt-1">
              <b-col cols="12">
                <p class="font-weight-bold mb-0">More Info</p>
                <vue2-tinymce-editor
                  v-if="showAdditionalInfo"
                  :key="'additionalInfo'"
                  id="additionalInfo"
                  v-model="additionalInfo"
                  :options="{ ...editorOptions }"
                />
              </b-col>
            </b-row>
          </b-card>

          <div class="custom-tabs">
            <b-tabs pills nav-class="w-100 d-flex" content-class="mt-3">
              <b-tab
                title="Racing"
                title-item-class="flex-fill text-center custom-tab-title"
              >
                <b-card class="mt-2">
                  <b-row>
                    <b-col cols="12">
                      <h5 class="text-body font-weight-bolder">
                        Race Selection
                      </h5>
                    </b-col>
                    <b-col cols="12">
                      <b-row>
                        <b-col md="5">
                          <p
                            class="font-weight-bold mb-0 d-flex align-items-center"
                          >
                            <feather-icon
                              icon="CalendarIcon"
                              style="margin-right: 5px; margin-top: -3px"
                            />
                            Browse Calendar
                          </p>
                          <flat-pickr
                            id="startDate"
                            v-model="selectedRaceDate"
                            class="form-control"
                            placeholder="mm/dd/yyyy"
                          />
                        </b-col>
                        <b-col mb="7" class="pl-0">
                          <p
                            class="font-weight-bold mb-0 d-flex align-items-center"
                          >
                            Selected Date
                          </p>
                          <div
                            class="d-flex align-items-center pl-2 border"
                            style="
                              background: #f8f9fa;
                              font-weight: 800;
                              height: 38px;
                              border-radius: 5px;
                            "
                          >
                            {{
                              format(
                                new Date(selectedRaceDate),
                                "EEEE d MMMM yyyy"
                              )
                            }}
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-col md="12" class="mb-2 mt-2">
                      <p class="m-0">
                        <span class="font-weight-bold mr-1">Racing Code*</span>
                        <small>(Leave blank to show all codes)</small>
                      </p>
                      <div
                        class="border"
                        style="
                          background: #fcfcfd;
                          border-radius: 5px;
                          padding: 15px 20px;
                        "
                      >
                        <b-form-checkbox-group
                          v-model="selectedRacingCodes"
                          class="d-flex flex-column"
                          style="gap: 5px"
                        >
                          <b-form-checkbox value="R"
                            >Thoroughbreds</b-form-checkbox
                          >
                          <b-form-checkbox value="G"
                            >Greyhounds</b-form-checkbox
                          >
                          <b-form-checkbox value="H">Harness</b-form-checkbox>
                        </b-form-checkbox-group>
                      </div>
                    </b-col>

                    <b-col md="12" class="mb-2">
                      <b-row>
                        <!-- MEETINGS -->
                        <b-col md="6">
                          <p style="margin-bottom: 5px">
                            Meetings
                            <b-form-checkbox
                              :checked="selectAllMeetings"
                              @change="checkSelectAllMeeting()"
                              inline
                              class="ml-2"
                            >
                              <Spinner
                                v-if="loadingAllMeetings"
                                variant="primary"
                                style="margin-bottom: 2px; margin-right: 3px"
                              />All Meetings</b-form-checkbox
                            >
                          </p>
                          <div
                            class="meeting-list-container border"
                            style="
                              background: #fcfcfd;
                              padding: 15px;
                              max-height: 300px;
                              min-height: 200px;
                              overflow-y: auto;
                            "
                          >
                            <div
                              class="text-center mt-5"
                              v-if="!meetings.length"
                            >
                              Select a date to view meetings
                            </div>
                            <div v-else>
                              <div
                                v-for="meeting in meetings"
                                :key="meeting.meetingId"
                                class="d-flex justify-content-between align-items-center"
                                :class="{
                                  'meeting-item-selected':
                                    selectedMeetings &&
                                    selectedMeetings.meetingId ===
                                      meeting.meetingId,
                                  'meeting-item':
                                    !selectedMeetings ||
                                    selectedMeetings.meetingId !==
                                      meeting.meetingId,
                                }"
                                @click="toggleMeetingSelection(meeting)"
                                style="cursor: pointer; padding: 5px 8px"
                              >
                                <div>
                                  <small
                                    class="font-weight-bold mr-1"
                                    style="font-size: 14px"
                                    >{{ meeting.venueName }}</small
                                  >
                                  <small>{{ meeting.state }} - 10 races</small>
                                </div>
                                <b-badge
                                  :variant="
                                    getBadgeVariant(
                                      convertMeetingType(meeting.meetingType)
                                    )
                                  "
                                  style="font-size: 10px"
                                  >{{
                                    convertMeetingType(meeting.meetingType)
                                  }}</b-badge
                                >
                              </div>
                            </div>
                          </div>
                        </b-col>

                        <!-- RACES -->
                        <b-col md="6">
                          <p style="margin-bottom: 5px">
                            Races
                            <b-form-checkbox
                              :checked="selectAllRaces"
                              @change="checkSelectAllRace()"
                              inline
                              class="ml-2"
                              >Select All Races</b-form-checkbox
                            >
                          </p>
                          <div
                            class="race-list-container border"
                            style="
                              background: #fcfcfd;
                              padding: 15px;
                              max-height: 300px;
                              min-height: 200px;
                              overflow-y: auto;
                            "
                          >
                            <div class="text-center mt-5" v-if="!races.length">
                              Select a meeting to view races
                            </div>
                            <div v-else>
                              <b-form-checkbox-group
                                v-model="selectedRaces"
                                stacked
                                class="d-flex flex-column"
                                style="gap: 5px"
                              >
                                <b-form-checkbox
                                  v-for="race in races"
                                  :key="race.eventNo"
                                  :value="race"
                                >
                                  Race {{ race.eventNo }} -
                                  {{ race.eventName }} -
                                  {{
                                    format(new Date(race.utcTime), "hh:mm aa")
                                  }}
                                </b-form-checkbox>
                              </b-form-checkbox-group>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>

                    <!-- SELECTED RACES -->
                    <b-col class="mb-2">
                      <div class="d-flex align-items-center mb-1">
                        <p class="form-label mb-0 me-2 mr-1">Selected Races</p>
                        <span
                          class="badge bg-secondary"
                          style="line-height: 10px; padding: 6px"
                          >{{ selectedRaces.length }}</span
                        >
                      </div>
                      <div
                        class="border"
                        style="
                          background: #f8f9fa;
                          border-radius: 5px;
                          min-height: 80px;
                          max-height: 500px;
                          overflow-y: auto;
                        "
                      >
                        <b-col>
                          <p v-if="!selectedRaces.length" class="mt-1">
                            No races selected
                          </p>
                          <div
                            v-else
                            class="mt-1 mb-1 d-flex flex-wrap"
                            style="gap: 4px"
                          >
                            <div
                              v-for="item in selectedRaces"
                              :key="item.raceId"
                              class="d-flex align-items-center active-position font-weight-bold"
                              style="
                                gap: 6px;
                                width: fit-content;
                                padding: 2px 6px;
                                border-radius: 5px;
                              "
                            >
                              {{ item.venueName }}
                              <small
                                style="
                                  width: 6px;
                                  height: 6px;
                                  border-radius: 100%;
                                  background: white;
                                "
                              ></small>
                              {{
                                format(new Date(item.utcTime), "E, d MMM yyyy")
                              }}
                              <small
                                style="
                                  width: 6px;
                                  height: 6px;
                                  border-radius: 100%;
                                  background: white;
                                "
                              ></small>
                              Race {{ item.eventNo }}: {{ item.eventName }}
                              <feather-icon
                                icon="XIcon"
                                style="color: white"
                                class="cursor-pointer"
                                @click="handleRemoveRaceItem(item)"
                              />
                            </div>
                          </div>
                        </b-col>
                      </div>
                    </b-col>
                  </b-row>
                </b-card>

                <b-card class="mt-2">
                  <b-row>
                    <b-col cols="12">
                      <h5 class="text-body font-weight-bolder">
                        Race MBS Refund Criteria
                      </h5>
                    </b-col>
                    <b-col cols="12">
                      <p class="font-weight-bold mb-0">Position Criteria*</p>
                      <div class="d-flex">
                        <div
                          v-for="i in 21"
                          :key="i"
                          class="box"
                          style="padding: 6px 8px"
                          @click="handleSelectedPosition(i + 1)"
                          :class="{
                            'active-position': selectedPosition.some(
                              (item) => item === i + 1
                            ),
                          }"
                        >
                          {{ getOrdinalSuffix(i + 1) }}
                        </div>
                      </div>
                      <p class="mt-2 text-center">OR</p>

                      <div class="mt-3">
                        <div>
                          <vue-slider
                            v-model="range"
                            :min="1"
                            :max="24"
                            :dot-size="16"
                            :tooltip="'always'"
                            :lazy="true"
                            :interval="1"
                            :marks="marksRange"
                            :process-style="{ backgroundColor: '#20c997' }"
                            :dot-style="{ border: '2px solid #ccc' }"
                            :tooltip-formatter="formatter"
                          />
                          <p class="text-center mt-2">
                            {{ range[0] }}th - {{ range[1] }}th
                          </p>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-card>
              </b-tab>
            </b-tabs>
          </div>

          <b-card>
            <b-row>
              <b-col cols="12">
                <h5 class="font-weight-bolder text-body">Refund Settings</h5>
              </b-col>
              <b-col cols="12">
                <b-row>
                  <b-col cols="12" md="6">
                    <p class="font-weight-bold mb-0">Refund Type</p>
                    <v-select
                      v-model="dataSettingMBS.discountType"
                      :options="optionsType"
                      :reduce="(val) => val.value"
                      :clearable="false"
                      @input="(val) => (option = val.value)"
                      class="w-100"
                    />
                  </b-col>
                  <b-col cols="12" md="6">
                    <p class="font-weight-bold mb-0">Maximum Refund Amount</p>
                    <b-form-input
                      v-model="dataSettingMBS.maxDiscount"
                      placeholder="$50"
                      type="number"
                    />
                  </b-col>
                </b-row>

                <b-row class="mt-1">
                  <b-col cols="12">
                    <p class="font-weight-bold mb-0">Minimum Bet Amount</p>
                    <b-form-input
                      v-model="dataSettingMBS.minDiscount"
                      placeholder="$10"
                      type="number"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>

          <b-card v-if="!$router.currentRoute.params.userId">
            <b-row>
              <b-col
                cols="12"
                class="d-flex align-items-center justify-content-between mb-1"
                ><h5 class="font-weight-bolder text-body">
                  Customer Eligibility
                </h5>
                <input
                  ref="fileInput"
                  type="file"
                  accept=".csv"
                  hidden
                  @change="handleFileUpload"
                />
                <b-button
                  size="sm"
                  variant="outline-primary"
                  @click="onClickInput"
                >
                  <feather-icon icon="UploadIcon" />

                  CSV File Upload
                </b-button>
              </b-col>
              <b-col cols="12">
                <div>
                  <div
                    class="d-flex align-items-center mb-1 cursor-pointer"
                    style="border-bottom: 1px solid #dee2e6"
                  >
                    <div
                      @click="activeTabCustomer = 'Customer Profiles'"
                      style="padding: 6px 16px"
                      :class="{
                        'active-tab': activeTabCustomer === 'Customer Profiles',
                      }"
                    >
                      Customer Profiles
                    </div>
                    <div
                      style="
                        padding: 6px 16px;
                        opacity: 0.45;
                        cursor: default;
                        user-select: none;
                      "
                      :class="{
                        'active-tab': activeTabCustomer === 'Customer Segments',
                      }"
                    >
                      Customer Segments
                    </div>
                  </div>

                  <b-row>
                    <b-col style="min-height: 100px">
                      <!-- Customer Profiles -->
                      <div
                        v-if="activeTabCustomer === 'Customer Profiles'"
                        class="grid-3"
                      >
                        <div
                          class="d-flex align-items-center cursor-pointer"
                          v-for="item in profiles"
                          :key="item"
                          style="
                            border: 1px solid #dee2e6;
                            border-radius: 5px;
                            gap: 10px;
                            padding: 8px 10px;
                          "
                          :style="{
                            background: selectedProfile.some((i) => i === item)
                              ? '#0D6EFD'
                              : '#f8f9fa',
                            color: selectedProfile.some((i) => i === item)
                              ? 'white'
                              : 'black',
                          }"
                          @click="handleSelectProfile(item)"
                        >
                          <div
                            class="d-flex justify-content-center align-items-center"
                            style="
                              width: 16px;
                              height: 16px;
                              border-radius: 2px;
                              border: 1px solid #dee2e6;
                            "
                            :style="{
                              background: selectedProfile.some(
                                (i) => i === item
                              )
                                ? '#0D6EFD'
                                : 'white',
                            }"
                          >
                            <feather-icon
                              icon="CheckIcon"
                              style="color: white"
                            />
                          </div>
                          {{ item }}
                        </div>
                      </div>

                      <!-- Customer Segments -->
                      <div
                        v-else
                        style="
                          opacity: 0.45;
                          cursor: default;
                          user-select: none;
                        "
                      >
                        <draggable
                          :list="customerSegments"
                          :group="{ name: 'tag', pull: 'clone', put: false }"
                          @change="handleDrag"
                          class="d-flex flex-wrap w-100"
                          :sort="false"
                        >
                          <b-col
                            v-for="(tag, index) in customerSegments"
                            :key="index"
                            cols="6"
                            md="3"
                            style="padding: 6px"
                          >
                            <b-card
                              border-variant="secondary"
                              body-class="p-0"
                              class="mb-0"
                              style="padding: 8px; border-radius: 4px"
                              :data-item="JSON.stringify(tag)"
                              ><span>{{ tag.name }}</span></b-card
                            >
                          </b-col>
                        </draggable>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>

            <!-- Customer Picker Section -->
            <b-row class="mt-2">
              <b-col cols="12" class="mb-1">
                <h5 class="font-weight-bolder text-body">Customers</h5>
              </b-col>
              <b-col cols="12" md="6">
                <b-card no-body class="border" style="overflow: hidden">
                  <!-- Sticky Search -->
                  <div
                    class="p-1"
                    style="
                      border-bottom: 1px solid #e0e0e0;
                      position: sticky;
                      top: 0;
                      z-index: 2;
                      background: white;
                    "
                  >
                    <b-form-input
                      v-model="userPickerSearch"
                      placeholder="Search by username..."
                    />
                  </div>
                  <!-- Scrollable User List -->
                  <div
                    ref="userPickerList"
                    style="max-height: 320px; overflow-y: auto"
                    @scroll="handleUserListScroll"
                  >
                    <div
                      v-if="userPickerLoading && userPickerUsers.length === 0"
                      class="text-center py-3 text-muted"
                    >
                      <b-spinner small /> Loading...
                    </div>
                    <div
                      v-else-if="
                        !userPickerLoading && userPickerUsers.length === 0
                      "
                      class="text-center py-3 text-muted"
                    >
                      No users found
                    </div>
                    <div
                      v-for="user in userPickerUsers"
                      :key="user.userId"
                      class="d-flex align-items-center px-2 py-1"
                      style="
                        border-bottom: 1px solid #f0f0f0;
                        cursor: pointer;
                        transition: background 0.15s;
                      "
                      :style="
                        isUserConfirmed(user.userId)
                          ? 'background:#f0fff4'
                          : userPickerVerifyingId === user.userId
                          ? 'background:#f8f9fa'
                          : ''
                      "
                      @click="handleSelectUser(user)"
                    >
                      <b-avatar
                        size="28"
                        :text="
                          (user.firstName ||
                            user.username ||
                            '?')[0].toUpperCase()
                        "
                        variant="light-primary"
                        class="mr-1"
                      />
                      <div style="flex: 1; min-width: 0">
                        <div
                          class="font-weight-bold text-truncate"
                          style="font-size: 13px"
                        >
                          {{ user.firstName }} {{ user.lastName }}
                        </div>
                        <div
                          class="text-muted text-truncate"
                          style="font-size: 11px"
                        >
                          {{ user.username }} &bull; {{ user.userId }}
                        </div>
                      </div>
                      <b-spinner
                        v-if="userPickerVerifyingId === user.userId"
                        small
                        class="ml-1"
                      />
                      <feather-icon
                        v-else-if="isUserConfirmed(user.userId)"
                        icon="CheckIcon"
                        size="16"
                        class="ml-1"
                        style="color: #28a745; flex-shrink: 0"
                      />
                    </div>
                    <div
                      v-if="userPickerLoading && userPickerUsers.length > 0"
                      class="text-center py-2 text-muted"
                    >
                      <b-spinner small /> Loading more...
                    </div>
                  </div>
                </b-card>
              </b-col>

              <!-- Confirmed Users List -->
              <b-col cols="12" md="6">
                <b-card
                  no-body
                  class="border"
                  style="overflow: hidden; min-height: 60px"
                >
                  <div style="max-height: 362px; overflow-y: auto">
                    <div
                      v-if="confirmedUsers.length === 0"
                      class="text-center text-muted py-3"
                      style="font-size: 13px"
                    >
                      No users selected yet.
                    </div>
                    <div
                      v-for="(u, idx) in confirmedUsers"
                      :key="u.userId"
                      class="d-flex align-items-center px-2 py-1"
                      style="
                        border-bottom: 1px solid #cce5ff;
                        background: #e8f4ff;
                      "
                    >
                      <b-avatar
                        size="28"
                        :text="
                          (u.firstName || u.username || '?')[0].toUpperCase()
                        "
                        variant="light-primary"
                        class="mr-1"
                      />
                      <div style="flex: 1; min-width: 0">
                        <div
                          class="font-weight-bold text-truncate"
                          style="font-size: 13px"
                        >
                          {{ u.firstName }} {{ u.lastName }}
                        </div>
                        <div
                          class="text-muted text-truncate"
                          style="font-size: 11px"
                        >
                          {{ u.username }} &bull; {{ u.userId }}
                        </div>
                      </div>
                      <b-button
                        size="sm"
                        variant="flat-danger"
                        class="p-0 ml-1"
                        style="line-height: 1; min-width: 24px"
                        @click="removeConfirmedUser(idx)"
                      >
                        <feather-icon icon="XIcon" size="14" />
                      </b-button>
                    </div>
                  </div>
                </b-card>
                <div class="mt-1 mb-1 text-right">
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    :disabled="confirmedUsers.length === 0"
                    @click="handleAddConfirmedUsersToSegment"
                  >
                    <feather-icon
                      icon="ArrowRightIcon"
                      size="14"
                      class="mr-25"
                    />
                    Set Recurrence List Selected
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="mt-1" style="margin-bottom: 5px">
                <small class="text-muted text-sm"
                  >Drag items to the table on the right to set recurring
                  issuance</small
                >
              </b-col>
              <b-col>
                <draggable
                  :value="selectedSegment"
                  @change="handleDrag"
                  @add="handleDrop"
                  group="tag"
                  class="w-100"
                >
                  <div style="border: 1px solid #dee2e6; border-radius: 5px">
                    <p
                      style="
                        background: #f8f9fa;
                        font-weight: 800;
                        border-radius: 5px 5px 0 0;
                        padding: 8px 10px;
                        border-bottom: 1px solid #dee2e6;
                      "
                    >
                      Segment
                    </p>

                    <div
                      v-if="selectedSegment.length === 0"
                      class="d-flex align-items-center justify-content-center"
                      style="min-height: 100px"
                    >
                      <div>
                        Drag profiles or segments here to include in this
                        promotion
                      </div>
                    </div>
                    <div v-else>
                      <div
                        v-for="(item, ind) in selectedSegment"
                        :key="ind"
                        class="d-flex justify-content-between"
                        style="
                          border-bottom: 1px solid #dee2e6;
                          padding: 6px 16px;
                        "
                      >
                        <div class="d-flex flex-column">
                          <span style="font-weight: 800">{{ item.name }}</span>
                          <span
                            style="font-size: 12px"
                            v-if="item.selectedUsers"
                            >{{ item.selectedUsers.length }} customers from
                            CSV</span
                          >
                        </div>
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          @click="deleteSegmentItem(item)"
                          style="height: 29px !important"
                        >
                          Remove
                        </b-button>
                      </div>
                    </div>
                  </div>
                </draggable>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-card>
            <h5 class="font-weight-bold mb-0">Marketing Assets</h5>
            <div class="mt-1">
              <b-tabs pills>
                <b-tab active>
                  <template #title>
                    <span class="d-flex align-items-center" style="gap: 6px">
                      Banner
                      <feather-icon
                        :icon="
                          isBannerComplete ? 'CheckCircleIcon' : 'XCircleIcon'
                        "
                        size="16"
                        :class="
                          isBannerComplete ? 'text-success' : 'text-danger'
                        "
                      />
                    </span>
                  </template>
                  <b-row>
                    <b-col
                      md="3"
                      sm="6"
                      v-for="banner in banners"
                      :key="banner.key"
                    >
                      <b-form-group>
                        <p class="font-weight-bold mb-0">
                          {{ banner.label }}
                        </p>

                        <!-- File input -->
                        <b-form-file
                          v-model="banner.file"
                          accept="image/*"
                          @input="onFileChange(banner)"
                          placeholder="Choose File"
                          browse-text="Choose File"
                        ></b-form-file>

                        <small class="text-muted d-block mt-1">{{
                          banner.desc
                        }}</small>

                        <!-- Preview + Loading -->
                        <b-skeleton
                          v-if="banner.loading"
                          class="skeleton-box mx-auto rounded border"
                          style="width: 100%; min-height: 150px"
                        ></b-skeleton>

                        <img
                          v-else-if="
                            banner.previewUrl &&
                            formBanner.bannerPosition === banner.key
                          "
                          :src="banner.previewUrl"
                          alt="preview"
                          class="img-fluid rounded border"
                          style="
                            width: 100%;
                            min-width: 100%;
                            min-height: 150px;
                            height: 150px;
                            object-fit: cover;
                          "
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <validation-provider
                        #default="{ errors }"
                        name="banner link"
                        :rules="
                          formBanner.bannerPosition ? 'required' : undefined
                        "
                      >
                        <b-form-group
                          label="Banner Link URL"
                          label-class="font-weight-bold"
                        >
                          <b-form-input
                            v-model="formBanner.bannerLink"
                            placeholder="https://example.com/promotion"
                          ></b-form-input>
                          <div>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </div>
                          <small class="text-muted"
                            >Where should users go when they click the
                            banner?</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <b-row>
                        <b-col cols="2">
                          <validation-provider
                            #default="{ errors }"
                            name="start date"
                            :rules="
                              formBanner.bannerPosition ? 'required' : undefined
                            "
                          >
                            <b-form-group label="Start Date">
                              <flat-pickr
                                :value="formBanner.startDate"
                                id="range-picker"
                                class="form-control"
                                :config="configDateBanner"
                                placeholder="dd/mm/yyyy"
                                @input="(val) => (formBanner.startDate = val)"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col cols="2">
                          <validation-provider
                            #default="{ errors }"
                            name="start date"
                            :rules="
                              formBanner.bannerPosition ? 'required' : undefined
                            "
                          >
                            <b-form-group label="End Date">
                              <flat-pickr
                                :value="formBanner.endDate"
                                id="range-picker"
                                class="form-control"
                                :config="configDateBanner"
                                placeholder="dd/mm/yyyy"
                                @input="(val) => (formBanner.endDate = val)"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>

                  <b-row class="mt-1"
                    ><b-col>
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <h6 class="font-weight-bold mb-0">Desktop Preview</h6>
                      </div>
                      <div class="mt-2">
                        <DesktopUI
                          :banners="banners"
                          :bannerPosition="formBanner.bannerPosition"
                        />
                      </div> </b-col
                  ></b-row>

                  <b-row class="mt-1">
                    <b-col cols="12">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <h6 class="font-weight-bold mb-0">Mobile Preview</h6>
                      </div>
                      <div class="mt-1">
                        <MobileUI :bannerCarousel="banners[0]" />
                      </div>
                    </b-col>
                  </b-row>
                </b-tab>

                <!-- INAPP TAB -->
                <b-tab title="INAPP">
                  <p class="text-muted">INAPP configuration here</p>
                </b-tab>

                <!-- EMAIL TAB -->
                <b-tab title="Email">
                  <p class="text-muted">Email template configuration</p>
                </b-tab>

                <!-- SMS TAB -->
                <b-tab title="SMS">
                  <p class="text-muted">SMS content configuration</p>
                </b-tab>
              </b-tabs>
            </div>
          </b-card>
        </b-col>
        <b-col cols="12">
          <b-card>
            <h5 class="font-weight-bold mb-0">
              Terms & Conditions (Mandatory)
            </h5>
            <div class="mt-1">
              <b-form-group label="Choose Template">
                <b-form-select
                  v-model="templateId"
                  :options="templates"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Terms Content">
                <b-form-textarea
                  v-model="termFinalContent"
                  rows="4"
                ></b-form-textarea>
                <small>You can edit the template text before publishing</small>
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>

    <b-row>
      <b-col cols="12" class="text-right">
        <b-button
          @click="$router.push('/promotions/money-back-specials')"
          variant="outline-secondary"
          class="mr-1"
        >
          Cancel
        </b-button>
        <b-button
          @click="
            handleCreatePromotion({ status: 'inactive', action: 'draft' })
          "
          variant="outline-secondary"
          class="mr-1"
          :disabled="loadingAction === 'draft' && loadingCreatePromotion"
          style="min-width: 136px"
        >
          Save as Draft
        </b-button>

        <b-button
          :disabled="loadingAction === 'publish' && loadingCreatePromotion"
          @click="
            handleCreatePromotion({ status: 'active', action: 'publish' })
          "
          variant="primary"
          style="min-width: 172px"
          class="mr-1"
        >
          Publish Promotion
        </b-button>
        <b-button
          :disabled="loadingAction === 'now' && loadingCreatePromotion"
          @click="
            handleCreatePromotion({
              status: 'active',
              isNow: true,
              action: 'now',
            })
          "
          variant="primary"
          style="min-width: 172px"
        >
          Publish Promotion Now
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Spinner from "@core/components/Spinner";
import {
  BButton,
  BCard,
  BCol,
  BPagination,
  BRow,
  BButtonGroup,
  BTable,
  BCardBody,
  BFormInput,
  BMedia,
  BAvatar,
  BProgress,
  BProgressBar,
  BFormTextarea,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BImg,
  BFormCheckboxGroup,
  BFormSelect,
  BInputGroup,
  BFormFile,
  BTab,
  BTabs,
  BBadge,
  BSkeleton,
  BSpinner,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import DualListbox from "../../components/DuoListBox.vue";
import { formatDateSend, getOrdinalSuffix } from "@/helpers/utils";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import draggable from "vuedraggable";
import { mapState, mapActions } from "vuex";
import { addDays, endOfDay, format, startOfDay, subDays } from "date-fns";
import useToastHandler from "@/services/toastHandler";
import { parse } from "csv-parse";
import { v4 as uuidv4 } from "uuid";
import { Vue2TinymceEditor } from "vue2-tinymce-editor";
import MobileUI from "../../../marketing/BannerManagement/components/MobileUI.vue";
import DesktopUI from "../../../marketing/BannerManagement/components/DesktopUI.vue";
import { sanitizePayload } from "@/helpers/utils";

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BPagination,
    vSelect,
    Spinner,
    BButtonGroup,
    BTable,
    BCardBody,
    BFormInput,
    BAvatar,
    flatPickr,
    BProgress,
    BProgressBar,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BImg,
    BFormCheckboxGroup,
    BFormSelect,
    BInputGroup,
    BFormFile,
    DualListbox,
    VueSlider,
    BTab,
    BTabs,
    BBadge,
    draggable,
    Vue2TinymceEditor,
    MobileUI,
    DesktopUI,
    BSkeleton,
    BSpinner,
  },
  data() {
    const banners = [
      {
        key: "carousel",
        label: "Carousel Banner (Web & Mobile)",
        desc: "Inside website carousel - 1200x400px",
        width: 1200,
        height: 400,
        resourceId: null,
        previewUrl: null,
        loading: false,
      },
      {
        key: "top",
        label: "Top Banner",
        desc: "Full-width top banner - 1920x150px",
        width: 1920,
        height: 150,
        resourceId: null,
        previewUrl: null,
        loading: false,
      },
      {
        key: "left",
        label: "Left Sidebar Banner",
        desc: "Left side promotional banner - 220x600px",
        width: 220,
        height: 600,
        resourceId: null,
        previewUrl: null,
        loading: false,
      },
      {
        key: "right",
        label: "Right Sidebar Banner",
        desc: "Right side promotional banner - 300x600px",
        width: 300,
        height: 600,
        resourceId: null,
        previewUrl: null,
        loading: false,
      },
    ];
    return {
      max: 4,
      value: 2,
      name: "",
      currentResource: null,
      configDate: {
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d H:i",
        altFormat: "d/m/Y H:i (AEDT)",
        altInput: true,
        static: true,
      },
      optionsType: [
        { label: "Bonus Bet", value: "mbs-bonus" },
        { label: "Cash Refund", value: "mbs-cash" },
      ],
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 32,
        height: 32,
      },
      matchIndex: 0,
      matchPercentage: 25,

      range: [4, 10],
      marksRange: {
        1: "1st",
        24: "24th",
      },
      selectedPosition: [],

      selectedRacingCodes: [],
      meetings: [],
      races: [],
      selectedMeetings: null,
      selectedRaces: [],

      profiles: [],
      selectedProfile: [],
      activeTabCustomer: "Customer Profiles",
      selectedSegment: [],
      dataSettingMBS: {
        discountType: "mbs-bonus",
        minDiscount: null,
        maxDiscount: null,
        activeStatus: "inactive",
      },
      selectedRaceDate: new Date(),
      selectAllMeetings: false,
      selectAllRaces: false,
      loadingAllMeetings: false,

      editData: null,
      description: "",
      descriptionHTML: "",
      additionalInfo: "",
      editorOptions: {
        forced_root_block: "div",
        height: 200,
        content_style: `
        html, body {
          background-color: #0766AA !important; 
          height: 100%;                         
          margin: 0;                        
          padding: 10px;               
          font-family: Arial, sans-serif;
          box-sizing: border-box;
        }
        
      `,
        forced_root_block_attrs: {
          style: "color: white;",
        },
      },
      showAdditionalInfo: false,
      templateId: null,
      termFinalContent: "",
      banners,
      formBanner: {
        bannerLink: "",
        bannerPosition: "",
        startDate: "",
        endDate: "",
      },
      configDateBanner: {
        enableTime: true,
        noCalendar: false,
        time_24hr: true,
        altFormat: "d-m-Y H:i",
      },
      templates: [],
      loadingAction: null,
      // User Picker
      userPickerSearch: "",
      userPickerUsers: [],
      userPickerLoading: false,
      userPickerPage: 1,
      userPickerHasMore: true,
      userPickerVerifyingId: null,
      confirmedUsers: [],
    };
  },
  mounted() {
    setTimeout(() => {
      this.showAdditionalInfo = true;
    }, 100);
  },
  watch: {
    userPickerSearch: {
      handler() {
        clearTimeout(this._userPickerSearchTimer);
        this._userPickerSearchTimer = setTimeout(() => {
          this.handleUserPickerSearch();
        }, 300);
      },
    },
    selectedPosition(val) {
      if (val.length > 0) {
        this.range = [1, 1];
      }
    },
    range(val) {
      if (val.length === 2 && val[0] !== 1 && val[1] !== 1) {
        this.selectedPosition = [];
      }
    },
    selectedRacingCodes(val) {
      this.fetchListMeetings();
    },
    selectedMeetings(val) {
      if (this.selectAllRaces) this.selectAllRaces = false;
    },
    selectedRaceDate(val) {
      this.fetchListMeetings();
    },
    termConditions(val) {
      if (!val) return;
      this.templates = val.map((i) => {
        return {
          ...i,
          value: i.id,
          text: i.name,
        };
      });
      const isUpdate = this.$router.currentRoute.params.id;
      if (!isUpdate) {
        this.templateId = this.templates[0].value;
        this.termFinalContent = this.templates[0].text;
      }
    },
    templateId(val) {
      const selectedTemplate = this.termConditions.find((i) => i.id === val);
      this.termFinalContent = selectedTemplate ? selectedTemplate.content : "";
    },
  },
  computed: {
    ...mapState("promotions/list", ["loadingCreatePromotion"]),
    ...mapState("promotions/price-promotions", ["termConditions"]),
    isBannerComplete() {
      return !!(
        this.formBanner.bannerPosition &&
        this.formBanner.bannerLink &&
        this.formBanner.startDate &&
        this.formBanner.endDate
      );
    },
  },
  async created() {
    this.updatePercentage();
    await Promise.all([
      this.fetchSegmentList(),
      this.fetchProfileList(),
      this.fetchListMeetings(),
      this.getTermConditions(),
    ]);
    await this.fetchDetailPromotion();
    this.loadUserPickerPage();
  },
  methods: {
    ...mapActions({
      getSegmentsList: "segment/list/getSegmentsList",
      getProfileList: "user/list/getProfileList",
      createNewPromotion: "promotions/list/createNewPromotion",
      getListMeetings: "trading/racing/getListMeetings",
      getRacesOfMeeting: "trading/racing/getRacesOfMeeting",
      getDetailPromotion: "promotions/list/getDetailPromotion",
      deletePromotionTarget: "promotions/list/deletePromotionTarget",
      updatePromotionTargets: "promotions/list/updatePromotionTargets",
      updatePromotion: "promotions/list/updatePromotion",
      createUserList: "user/list/createUserList",
      getUserList: "user/list/getUserListByGroup",
      getTermConditions: "promotions/price-promotions/getTermConditions",
      getAllUserList: "user/list/getUserList",
      uploadBannerImage: "marketing/banner/uploadBannerImage",
    }),
    getOrdinalSuffix,

    // User Picker methods
    handleUserPickerSearch() {
      this.userPickerUsers = [];
      this.userPickerPage = 1;
      this.userPickerHasMore = true;
      this.loadUserPickerPage();
    },
    async loadUserPickerPage() {
      if (this.userPickerLoading || !this.userPickerHasMore) return;
      this.userPickerLoading = true;
      try {
        const limit = 20;
        const data = await this.getAllUserList({
          search: this.userPickerSearch || "",
          limit,
          page: this.userPickerPage,
        });
        if (!data || data.length === 0) {
          this.userPickerHasMore = false;
        } else {
          this.userPickerUsers = [...this.userPickerUsers, ...data];
          this.userPickerPage += 1;
          if (data.length < limit) this.userPickerHasMore = false;
        }
      } catch (e) {
        this.userPickerHasMore = false;
      } finally {
        this.userPickerLoading = false;
      }
    },
    handleUserListScroll(e) {
      const el = e.target;
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 60;
      if (nearBottom && this.userPickerHasMore && !this.userPickerLoading) {
        this.loadUserPickerPage();
      }
    },
    isUserConfirmed(userId) {
      return this.confirmedUsers.some((u) => u.userId === userId);
    },
    async handleSelectUser(user) {
      if (this.userPickerVerifyingId) return;
      if (this.isUserConfirmed(user.userId)) {
        this.confirmedUsers = this.confirmedUsers.filter(
          (u) => u.userId !== user.userId
        );
        return;
      }
      this.userPickerVerifyingId = user.userId;
      try {
        this.confirmedUsers = [...this.confirmedUsers, user];
        this.showToastSuccess(
          "success",
          `User "${user.username || user.userId}" added.`
        );
      } catch (e) {
        this.showToastError(false, "Failed to add user.");
      } finally {
        this.userPickerVerifyingId = null;
      }
    },
    removeConfirmedUser(idx) {
      this.confirmedUsers.splice(idx, 1);
    },
    handleAddConfirmedUsersToSegment() {
      if (!this.confirmedUsers.length) return;
      const newSegment = {
        name: "Untitled",
        uuid: uuidv4(),
        selectedUsers: this.confirmedUsers.map((u) => u.userId),
        targetType: "UserList",
        source: "customer",
      };
      this.selectedSegment = [...this.selectedSegment, newSegment];
      this.confirmedUsers = [];
      this.showToastSuccess(
        "success",
        `${newSegment.selectedUsers.length} users added to recurrence list.`
      );
    },

    updatePercentage() {
      this.matchPercentage = (+this.matchIndex + 1) * 25;
    },
    showModalMarketing() {
      this.$refs.marketing.show();
    },
    formatter(value) {
      return `${value}`;
    },
    convertMeetingType(type) {
      switch (type) {
        case "R":
          return "Thoroughbred";
        case "G":
          return "Greyhound";
        case "H":
          return "Harness";
        default:
          return "";
      }
    },
    getBadgeVariant(type) {
      switch (type) {
        case "Thoroughbred":
          return "success";
        case "Greyhound":
          return "info";
        case "Harness":
          return "warning";
        default:
          return "secondary";
      }
    },
    toggleMeetingSelection(item) {
      this.selectedMeetings = item;
      this.fetchListRacesOfMeeting();
    },
    handleSelectProfile(item) {
      if (this.selectedProfile.some((i) => i === item))
        return (this.selectedProfile = this.selectedProfile.filter(
          (i) => i !== item
        ));
      this.selectedProfile = [...this.selectedProfile, item];
    },
    handleDrag(event) {},
    handleDrop(event) {
      const draggedTag = event.clone?.innerText?.trim();
      if (
        !draggedTag ||
        this.selectedSegment.some((i) => i.name === draggedTag)
      )
        return;
      const item = this.customerSegments.find((i) => i.name === draggedTag);
      this.selectedSegment.splice(event.newIndex, 0, {
        ...item,
      });
    },
    async fetchSegmentList() {
      const data = await this.getSegmentsList({
        limit: 100,
      });
      this.customerSegments = data.data.map((i) => {
        return {
          name: i.name,
          id: i.id,
        };
      });
    },
    async fetchProfileList() {
      const data = await this.getProfileList();
      this.profiles = data.map((i) => i.profileTypeId);
    },
    mapBannerForm(data) {
      if (!data) return;
      this.formBanner = {
        ...this.formBanner,
        bannerId: data.bannerId,
        startDate: data.startDate,
        endDate: data.endDate,
        bannerLink: data.bannerLink,
        bannerPosition: data.bannerPosition,
        platform: data.platform,
      };
    },
    mapBannerResource(data) {
      if (!data?.resources?.length) return;
      const index = this.banners.findIndex(
        (b) => b.key === data.bannerPosition
      );
      if (index === -1) return;
      const resource = data.resources[0];
      this.banners[index] = {
        ...this.banners[index],
        resourceId: resource?.resourceId || null,
        previewUrl: resource?.url || null,
      };
    },
    async fetchDetailPromotion() {
      if (!this.$router.currentRoute.params.id) return;
      const { data: data } = await this.getDetailPromotion(
        this.$router.currentRoute.params.id
      );
      this.name = data.name;
      this.additionalInfo = data.additionalInfo ? data.additionalInfo : "";
      this.description = data.description;
      this.descriptionHTML = data.descriptionHTML;
      this.dataSettingMBS = {
        discountType: data.discountType,
        minDiscount: data.minDiscount,
        maxDiscount: data.maxDiscount,
        activeStatus: data.status,
      };
      this.templateId = data.templateId || null;
      this.$nextTick(() => {
        this.termFinalContent = data.termFinalContent || "";
      });
      if (data.banner) {
        this.currentResource = data.banner?.resources?.[0] || null;
        this.mapBannerForm(data.banner);
        this.mapBannerResource(data.banner);
      }
      {
        const targets = data.targets.filter((i) => i.targetType !== "Profile");
        const selectedSegment = [];
        for (const i of targets) {
          if (i.targetType === "CustomerSegment") {
            const item = this.customerSegments.find((r) => r.id === i.targetId);
            if (item) {
              selectedSegment.push(item);
            }
            continue;
          }

          let list;
          if (i.targetType === "UserList") {
            list = await this.fetchUserList(i.targetId);
          }

          selectedSegment.push({
            id: i.targetId,
            ...i,
            name: "Untitled",
            selectedUsers: list,
          });
        }
        this.selectedSegment = selectedSegment;
      }

      this.selectedProfile = data.targets
        .filter((i) => i.targetType === "Profile")
        .map((i) => {
          const item = this.profiles.find((r) => r === i.targetId);
          return item;
        });

      this.selectedPosition = data.rules
        .filter((i) => i.conditionType === "position")
        .map((i) => Number(i.conditionValue));

      this.editData = data;
      this.getDataOfListRuleTypeLegId();
    },
    async fetchUserList(id) {
      const res = await this.getUserList(id);
      return res.data.map((i) => i.userId);
    },
    async getDataOfListRuleTypeLegId() {
      const list = this.editData.rules.filter(
        (i) => i.conditionType === "legId"
      );
      const racePromises = list.map((race) => {
        return this.getRacesOfMeeting({
          limit: 1,
          raceId: race.conditionValue,
        }).then((res) => {
          return {
            ...res[0],
          };
        });
      });

      const racesPerMeeting = await Promise.all(racePromises);
      this.selectedRaces = racesPerMeeting;
    },
    deleteSegmentItem(item) {
      this.selectedSegment = this.selectedSegment.filter(
        (i) => i.id !== item.id
      );
    },
    handleSelectedPosition(item) {
      if (this.selectedPosition.some((i) => i === item))
        return (this.selectedPosition = this.selectedPosition.filter(
          (i) => i !== item
        ));
      return (this.selectedPosition = [...this.selectedPosition, item]);
    },
    rangeFunctional(arr) {
      const [A, B] = arr;
      const length = B - A + 1;
      return Array.from({ length }, (_, index) => A + index);
    },
    async handleCreatePromotion({ status, isNow = false, action }) {
      const valid = await this.$refs.validateMBSForm.validate();
      if (!valid) return;
      if (this.$router.currentRoute.params.userId) {
        await this.handleCreatePromotionForUser(status);
        return;
      }
      const isUpdate = !!this.$router.currentRoute.params.id;
      this.dataSettingMBS.activeStatus = status;
      this.loadingAction = action;
      const { currentResource } = this;

      const sortTimeListRace = this.selectedRaces.sort(
        (a, b) => new Date(a.utcTime).getTime() - new Date(b.utcTime).getTime()
      );

      const formatSelectedPosition = this.selectedProfile.map((i) => {
        return {
          targetType: "Profile",
          targetId: i,
        };
      });

      const formatSelectedSegment = [];
      for (const i of this.selectedSegment) {
        if (!i.selectedUsers) {
          formatSelectedSegment.push({
            targetType: "CustomerSegment",
            targetId: i.id,
          });
          continue;
        }

        let targetUserListId;
        if (i && i.targetType === "UserList" && !i.targetId) {
          const resListId = await this.createUserList({
            userIds: i.selectedUsers,
          });
          if (resListId && resListId.data) targetUserListId = resListId.data;
        } else if (i.targetType === "UserList" && i.targetId) {
          targetUserListId = i.targetId;
        }

        formatSelectedSegment.push({
          targetType: "UserList",
          targetId: targetUserListId,
        });
      }

      const rules = !this.selectedPosition.length
        ? this.rangeFunctional(this.range)
        : this.selectedPosition;

      const bannerInfo = this.formBanner;
      const newId = this.banners.find(
        (b) => b.key === bannerInfo.bannerPosition
      )?.resourceId;

      if (!isUpdate) {
        bannerInfo.resourceIds = this.banners
          .filter((b) => b.resourceId)
          .map((b) => b.resourceId);
        bannerInfo.platform = "all";
      } else if (newId) {
        const oldId = currentResource?.resourceId;
        if (!oldId) {
          bannerInfo.resourceIds = [newId];
          bannerInfo.platform = "all";
        } else if (oldId !== newId) {
          bannerInfo.resources = [{ oldResourceId: oldId, resourceId: newId }];
        }
      }
      const data = sanitizePayload({
        name: this.name,
        description: this.description,
        descriptionHTML: this.descriptionHTML,
        additionalInfo: this.additionalInfo,
        type: "Money Back Specials",
        subType: "Single Racing",
        discountType: this.dataSettingMBS.discountType,
        discountValue: 100,
        maxDiscount: Number(this.dataSettingMBS.maxDiscount),
        minDiscount: Number(this.dataSettingMBS.minDiscount),
        status,
        startTime: this.formatDateSend(
          isNow
            ? new Date()
            : subDays(new Date(sortTimeListRace[0].utcTime || ""), 1)
        ),
        endTime: this.formatDateSend(
          addDays(
            new Date(
              sortTimeListRace[sortTimeListRace.length - 1].utcTime || ""
            ),
            10
          )
        ),
        rules: [
          ...rules.map((rule) => {
            return {
              conditionType: "position",
              conditionValue: `${rule}`,
            };
          }),
          ...this.selectedRaces.map((i) => {
            return {
              conditionType: "legId",
              conditionValue: i.raceId,
            };
          }),
        ],
        ...(!!bannerInfo.bannerPosition
          ? {
              bannerInfo: {
                ...bannerInfo,
                startDate: this.formatDateSend(bannerInfo.startDate),
                endDate: this.formatDateSend(bannerInfo.endDate),
              },
            }
          : {}),
        templateId: this.templateId,
        termFinalContent: this.termFinalContent,
      });
      if (isUpdate) {
        await Promise.all([
          this.handleUpdatePromotion(data),
          this.handleUpdatePromotionTargets([
            ...formatSelectedPosition,
            ...formatSelectedSegment,
          ]),
        ]);
        this.showToastSuccess(
          "success",
          "This promotion updated successfully!"
        );
        return;
      }
      const res = await this.createNewPromotion({
        ...data,
        targets: [...formatSelectedPosition, ...formatSelectedSegment],
      });
      if (res.data) {
        this.showToastSuccess(
          "success",
          "New Money Back Special created successfully!"
        );
        this.$router.push("/promotions/money-back-specials");
      }
    },
    async handleUpdatePromotion(data) {
      const res = await this.updatePromotion({
        promotionId: this.$router.currentRoute.params.id,
        ...data,
      });
      return res;
    },
    convertListToIdsTarget(l) {
      return l.reduce((acc, item, index) => {
        const key = `ids[${index}]`;

        acc[key] = item.id;

        return acc;
      }, {});
    },
    async handleUpdatePromotionTargets(list) {
      const resDelete = await this.deletePromotionTarget(
        this.convertListToIdsTarget(this.editData.targets)
      );
      if (!resDelete) return;
      const res = await this.updatePromotionTargets({
        promotionId: this.$router.currentRoute.params.id,
        targets: list,
      });
      return res;
    },
    convertListToIdsObject(l) {
      return l.reduce((acc, item, index) => {
        const key = `meetingTypes[${index}]`;

        acc[key] = item;

        return acc;
      }, {});
    },
    async fetchListMeetings() {
      const res = await this.getListMeetings({
        limit: 100,
        source: "RAS",
        meetingDateFrom: startOfDay(
          new Date(this.selectedRaceDate)
        ).toISOString(),
        meetingDateTo: endOfDay(new Date(this.selectedRaceDate)).toISOString(),
        ...(!!this.selectedRacingCodes.length &&
          this.convertListToIdsObject(this.selectedRacingCodes)),
      });
      this.meetings = res;
    },
    async fetchListRacesOfMeeting() {
      if (!this.selectedMeetings) return;
      const res = await this.getRacesOfMeeting({
        limit: 100,
        meetingId: this.selectedMeetings.meetingId,
      });
      this.races = res.map((i) => {
        return {
          ...i,
          venueName: this.selectedMeetings.venueName,
          meetingId: this.selectedMeetings.meetingId,
        };
      });
    },
    checkSelectAllRace() {
      this.selectAllRaces = !this.selectAllRaces;
      const listNoCurrentMeeting = this.selectedRaces.filter(
        (i) => i.meetingId !== this.selectedMeetings.meetingId
      );
      if (this.selectAllRaces) {
        this.selectedRaces = [...listNoCurrentMeeting, ...this.races];
      } else {
        this.selectedRaces = listNoCurrentMeeting;
      }
    },
    handleRemoveRaceItem(item) {
      this.selectedRaces = this.selectedRaces.filter(
        (i) => i.raceId !== item.raceId
      );
    },
    async checkSelectAllMeeting() {
      this.selectAllMeetings = !this.selectAllMeetings;

      const meetingIds = this.meetings.map((m) => m.meetingId);

      if (!this.selectAllMeetings) {
        this.selectedRaces = [];
        return;
      }
      this.loadingAllMeetings = true;
      const racePromises = this.meetings.map((meeting) => {
        return this.getRacesOfMeeting({
          limit: 100,
          meetingId: meeting.meetingId,
        }).then((res) => {
          return res.map((i) => ({
            ...i,
            venueName: meeting.venueName,
            meetingId: meeting.meetingId,
          }));
        });
      });

      const racesPerMeeting = await Promise.all(racePromises);

      const allRaces = racesPerMeeting.flat();

      const listNoCurrentMeeting = this.selectedRaces.filter(
        (i) => !meetingIds.includes(i.meetingId)
      );

      const combined = [...listNoCurrentMeeting, ...allRaces];
      const unique = combined.reduce((acc, cur) => {
        if (!acc.some((x) => x.raceId === cur.raceId)) acc.push(cur);
        return acc;
      }, []);

      this.selectedRaces = unique;
      this.loadingAllMeetings = false;
    },
    onClickInput() {
      const fileInput = this.$refs.fileInput;
      fileInput.click();
    },
    _resetInputFile() {
      this.$refs.fileInput.value = null;
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.parseCSV(reader.result);
      };
      reader.readAsText(file);
      this._resetInputFile();
    },
    parseCSV(csvData) {
      parse(csvData, { delimiter: "," }, (err, data) => {
        if (err) {
          console.error(err);
          return;
        }
        data.shift();
        const newList = data.map((i) => i[0]);

        if (newList.length > 0) {
          this.selectedSegment = [
            ...this.selectedSegment,
            {
              name: "Untitled",
              id: uuidv4(),
              targetType: "UserList",
              selectedUsers: newList,
            },
          ];
          this.activeTabCustomer = "Customer Segments";
        }
      });
    },
    async handleCreatePromotionForUser(status) {
      this.dataSettingMBS.activeStatus = status;

      const sortTimeListRace = this.selectedRaces.sort(
        (a, b) => new Date(a.utcTime).getTime() - new Date(b.utcTime).getTime()
      );

      const rules = !this.selectedPosition.length
        ? this.rangeFunctional(this.range)
        : this.selectedPosition;

      const data = {
        name: this.name,
        description: this.description,
        descriptionHTML: this.descriptionHTML,
        additionalInfo: this.additionalInfo,
        type: "Money Back Specials",
        subType: "Single Racing",
        discountType: this.dataSettingMBS.discountType,
        discountValue: 100,
        maxDiscount: Number(this.dataSettingMBS.maxDiscount),
        minDiscount: Number(this.dataSettingMBS.minDiscount),
        status,
        startTime: this.formatDateSend(
          subDays(new Date(sortTimeListRace[0].utcTime || ""), 1)
        ),
        endTime: this.formatDateSend(
          addDays(
            new Date(
              sortTimeListRace[sortTimeListRace.length - 1].utcTime || ""
            ),
            10
          )
        ),
        rules: [
          ...rules.map((rule) => {
            return {
              conditionType: "position",
              conditionValue: `${rule}`,
            };
          }),
          ...this.selectedRaces.map((i) => {
            return {
              conditionType: "legId",
              conditionValue: i.raceId,
            };
          }),
        ],
      };
      const res = await this.createNewPromotion({
        ...data,
        targets: [
          {
            targetType: "User",
            targetId: this.$router.currentRoute.params.userId,
          },
        ],
      });
      if (res.data) {
        this.showToastSuccess(
          true,
          "New Money Back Special created successfully!"
        );
        this.$router.push(
          `/customers/view/${this.$router.currentRoute.params.userId}`
        );
      }
    },
    async onFileChange(banner) {
      if (!banner.file) return;
      try {
        this.formBanner.bannerPosition = banner.key;
        banner.loading = true;
        const result = await this.uploadBannerImage(banner);
        banner.previewUrl = result[0].url;
        banner.resourceId = result[0].resourceId;
        banner.loading = false;
      } catch (error) {
        banner.loading = false;
      }
    },
  },
  setup() {
    const { showToastSuccess, showToastError } = useToastHandler();

    return {
      showToastSuccess,
      showToastError,

      format,
      formatDateSend,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";

p {
  margin-bottom: 0;
}
.circle-cancel {
  position: absolute;
  top: -4px;
  right: -7px;
  border: 1px solid black;
  background: white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.box {
  padding: 6px 10px;
  border: 1px solid #6c757d;
  border-left: none;
  cursor: pointer;
  &-active {
    background-color: #6c757d;
    color: white;
  }
  &:first-child {
    border-left: 1px solid #6c757d;
    border-radius: 4px 0 0 4px;
  }
  &:last-child {
    border-radius: 0 4px 4px 0;
  }
}
.custom-tab-title {
  background-color: white;
  color: black;
  font-weight: 500;
  &-active {
    background-color: #007bff;
    color: black;
    font-weight: 700;
  }
  &:last-child {
    border-right: none;
  }
}
</style>

<style lang="scss" scoped>
.meeting-list-container,
.race-list-container {
  border-radius: 0.25rem;
}

.meeting-item {
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
  background-color: white;
}

.meeting-item:last-child {
  border-bottom: none;
}

.meeting-item:hover {
  background-color: #e0e1e2;
}

.meeting-item-selected {
  background-color: #0d6efd;
  color: white;
}

.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.active-tab {
  color: #0d6efd;
  border: 1px solid #dee2e6;
  border-radius: 5px 5px 0 0;
  border-bottom: 1px solid #0d6efd;
}

.active-position {
  background: #0d6efd;
  color: white;
}
</style>
